import { Button, Text } from "@mantine/core";
import { GoogleLogo } from "@/components/Logos/GoogleLogo";

interface SignUpMethodSelectorProps {
  onGoogleSignUp: () => void;
  onEmailSignUp: () => void;
  googleLoading: boolean;
  primaryColor: string;
}

export const SignUpMethodSelector = ({
  onGoogleSignUp,
  onEmailSignUp,
  googleLoading,
  primaryColor,
}: SignUpMethodSelectorProps) => {
  return (
    <>
      <Button
        type="button"
        onClick={onGoogleSignUp}
        variant="outline"
        radius="md"
        size="md"
        disabled={googleLoading}
        loading={googleLoading}
        style={{
          width: "100%",
          borderColor: "#dadce0",
          color: "#3c4043",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "8px",
          cursor: googleLoading ? "not-allowed" : "pointer",
          opacity: googleLoading ? 0.6 : 1,
        }}
      >
        {!googleLoading && (
          <GoogleLogo width={18} height={18} style={{ marginRight: "8px" }} />
        )}
        Sign up with Google
      </Button>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginTop: "16px",
          marginBottom: "16px",
        }}
      >
        <div
          style={{
            flex: 1,
            height: "1px",
            backgroundColor: "#e0e0e0",
          }}
        />
        <Text
          size="sm"
          c="dimmed"
          style={{ margin: "0 16px", whiteSpace: "nowrap" }}
        >
          or
        </Text>
        <div
          style={{
            flex: 1,
            height: "1px",
            backgroundColor: "#e0e0e0",
          }}
        />
      </div>

      <Button
        type="button"
        onClick={onEmailSignUp}
        color={primaryColor}
        radius="md"
        size="md"
        disabled={googleLoading}
        style={{
          width: "100%",
          cursor: googleLoading ? "not-allowed" : "pointer",
          opacity: googleLoading ? 0.6 : 1,
        }}
      >
        Sign up with email
      </Button>
    </>
  );
};
